import React from 'react';

import { FormikSelect } from 'components/UiKit/FormikFields';
import FormField from 'screens/Equipment/components/FormField';
import { types } from '../../helpers/constants';

const EquipmentTypeField = () => {
  return (
    <FormField label="Type *" htmlFor="equipmentType">
      <FormikSelect
        id="equipmentType"
        name="equipmentType"
        items={types}
        placeholder="Select"
      />
    </FormField>
  );
};

export default EquipmentTypeField;
